import { Box, Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
// import ModalLevel from "../../modal/camiones/modalPermisos";
import ModalCliente from "../../modal/cliente/modalCliente";
import { PostDatos } from "../../services/cliente.services";
import { PostDatosEstante } from "../../services/estante.services";
  import { toast } from "react-toastify";
import ModalCharge from "../../modal/modalCharge";
import ModalEstante from "../../modal/estante/modalEstante";
import { es } from "date-fns/locale";
import { PostDatosFila } from "../../services/fila.services";
import ModalDepositoAmoxarifado from "../../modal/amoxarifado/modalDeposito";
import ModalEstanteGetOne from "../../modal/estante/modalEstantegetOne";


const Fila = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalClienteOpen, setIsModalClienteOpen] = useState(false);
  const [isModalEstanteOpen, setIsModalEstanteOpen] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
    const [selectedDeposito, setSelectedDeposito] = useState(null);

  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [selected, setSelected] = useState({
    descripcion: "",
    id_estante: "",
  });
  
  const [modalOpen, setModalOpen] = useState(false);
  const [idDepositoSeleccionado, setIdDepositoSeleccionado] = useState(null);
  const [depositoSeleccionado, setDepositoSeleccionado] = useState(null);
  const [descripcionUbicacion, setDescripcionUbicacion] = useState(""); 


  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const { id_estante,descripcion} = values;

    const valuesToSend = {
      descripcion: descripcion.toUpperCase(),
      id_estante
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const response = await PostDatosFila(valuesToSend);
      setRegistrationSuccess(true);
      toast.success("Registrado exitosamente", {
      position: "top-center", // o "bottom-center"
});
        setDescripcionUbicacion(""); // resetea lo que se ve
      setSelected(null); 
      resetForm();
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setError(error.message);
      toast.error("Ocurrió un error al registrar",  {
          position: "top-center", // o "bottom-center"
        });
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const handleSelectEstante = (estante) => {
    setSelected(estante);
    
    };


  return (
    <Box m="20px">
      <Header title="Registro Fila" subtitle="Registrar Fila" />

      <ModalCharge open={isLoading} />
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          descripcion: "",
          id_estante: ""
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Descripcion"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.descripcion || ""}
                  name="descripcion"
                  error={!!touched.descripcion && !!errors.descripcion}
                  helperText={touched.descripcion && errors.descripcion}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Ubicación"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={descripcionUbicacion}
                  name="id_estante"
                  error={!!touched.id_estante && !!errors.id_estante}
                  helperText={touched.id_estante && errors.id_estante}
                  sx={{ gridColumn: "span 2" }}

                  onClick={() => {    setDescripcionUbicacion("");
                    setFieldValue("id_estante", "");
                    setSelected(null);
                    setIdDepositoSeleccionado(null);
                    setDepositoSeleccionado(null);
                    setModalOpen(true);}}
                />
              
            
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                 <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        backgroundColor: "rgb(206, 220, 0)",
                        color: "black",
                        height: "7vh",
                        width: "10vw",
                        borderRadius: "20px",
                        "&:hover": { backgroundColor: "#bac609" },
                      }}
                    >
                      Guardar
                </Button>

              </Box>
            </form>

            <ModalDepositoAmoxarifado
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              onSelect={(deposito) => {
                setIdDepositoSeleccionado(deposito.id);
                setDepositoSeleccionado(deposito); 
                setModalOpen(false);
                setIsModalEstanteOpen(true);

              }}
            />
            <ModalEstanteGetOne
              open={isModalEstanteOpen}
              onClose={() => setIsModalEstanteOpen(false)}
              idDeposito={idDepositoSeleccionado}
              nombreDeposito={depositoSeleccionado?.deposito} 
              onSelect={(estante) => {
                setSelected(estante);
                setFieldValue("id_estante", estante?.id); // actualizás el campo id_estante
                setDescripcionUbicacion(
                  `${depositoSeleccionado?.deposito}, ${estante?.descripcion}`
                );
                setIsModalEstanteOpen(false);
              }}
            />

          </>
        )}
      </Formik>

    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  descripcion: yup.string().required("Descripcion requerida"),
  id_estante: yup.number().required("Campo requerido"),

});

export default Fila;
